import Marquee from "react-fast-marquee";

const ITEMS = [
  "Comfortable Furnished Stays",
  "Austin, Texas",
  "Professionally Managed",
  "Extended-Stay Ready",
];

export const BrandMarquee = () => (
  <div data-testid="brand-marquee" className="py-10 bg-[#F5F5F4] border-y border-[#E7E5E4] overflow-hidden">
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="px-10 text-3xl sm:text-4xl font-light tracking-tight text-[#1C1917]">{item}</span>
          <span className="w-2 h-2 rounded-full bg-[#8A9A86]" />
        </div>
      ))}
    </Marquee>
  </div>
);
